import { LogLevel } from './csmGlobal';

/*
 * All Error logging should go through these 2 functions.
 * Issues which degrade customer experience should call {@link logFatal}
 * Log level descriptions: https://w.amazon.com/bin/view/ClientSideMetrics/UserDocs/JavascriptErrors/#Error_levels
 * This will send messages/errors to RTLA, which can be analyzed to provide more information.
 */

/**
 * Logs a message to the console, with console.debug(message)
 * @param message text send to console
 */
export const logDebug = (message: string): void => {
    console.debug(message);
};

/**
 * Sends a warn message to RTLA.
 * @param message the text string of the warn
 * @param err the error object to log, if omitted, an error object will be created using message
 */
export const logWarn = (message: string, err?: Error | any): void => {
    console.warn(message, JSON.stringify(err));
    emitToRTLA('WARN', message, toError(message, err));
};

/**
 * Send an error message to RTLA. Use {@link logFatal} instead for issues which degrade customer experience.
 * @param message the text string of the error
 * @param err the error object to log, if omitted, an error object will be created using message
 */
export const logError = (message: string, err?: Error | any): void => {
    console.error(message, JSON.stringify(err));
    emitToRTLA('ERROR', message, toError(message, err));
};

/**
 * Send a fatal error message to RTLA. Use {@link logError} instead for non-critical errors.
 * @param message the text string of the error
 * @param err the error object to log, if omitted, an error object will be created using message
 */
export const logFatal = (message: string, err?: Error | any): void => {
    console.error(message, JSON.stringify(err));
    emitToRTLA('FATAL', message, toError(message, err));
};

const emitToRTLA = (level: LogLevel, message: string, err: Error): void => {
    window.ueLogError?.(err, {
        logLevel: level,
        attribution: 'APE-safeframe',
        message: message + ' | '
    });
};

const toError = (message: string, err: any): Error =>
    err instanceof Error ? err : err ? new Error(err) : new Error(message);
